import { render } from "./AcademicYear.vue?vue&type=template&id=736b4295"
import script from "./AcademicYear.vue?vue&type=script&lang=js"
export * from "./AcademicYear.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__